import { type FC } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthorizedRoute } from '../../../components/AuthorizedRoute'
import { Permission } from '../../../contexts/permission/PermissionModel'
import { LayoutWithLeftSidebar } from '../../LayoutWithLeftSidebar/LayoutWithLeftSidebar'
import { LockScreenWrapper } from '../../Plan/LockScreenWrapper/LockScreenWrapper'
import { UserScoresGroupedPage } from './UserScoresGroupedPage'
import { UserScoreDetailsPage } from './UserScoreDetailsPage'
import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

export const UserScoresRoutes: FC = () => {
  const { hasQuota, isFetching: quotasFetching, quotaSuccess } = useZocksQuota()
  const insightsEnabled = quotaSuccess && hasQuota('insights.enabled.value')

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  if (!insightsEnabled) {
    return <Navigate to='/insights' replace />
  }

  return (
    <AuthorizedRoute allowedTo={[Permission.INSIGHTS_READ]}>
      <LockScreenWrapper>
        <LayoutWithLeftSidebar>
          <Routes>
            <Route index element={<UserScoresGroupedPage />} />
            <Route path=':userId' element={<UserScoreDetailsPage />} />
          </Routes>
        </LayoutWithLeftSidebar>
      </LockScreenWrapper>
    </AuthorizedRoute>
  )
}
